import React, { type FC } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const rowBaseStyle = xcss({
	display: 'flex',
	gap: 'space.100',
	height: '50px',
	alignItems: 'center',
	borderBottomWidth: 'border.width',
	borderBottomStyle: 'solid',
	borderBottomColor: 'color.border',
});

const rowNoBorderStyle = xcss({ borderBottom: 'none' });

const rowSelectedStyle = xcss({
	backgroundColor: 'color.background.selected',
});

const rowFlexibleHeightStyle = xcss({ height: 'auto' });

const rowButtonStyles = xcss({
	cursor: 'pointer',
});

const rowDataStyles = xcss({
	backgroundColor: 'elevation.surface',
	transitionDuration: '0.1s',
	transitionProperty: 'background-color',
	transitionTimingFunction: 'ease-out',

	':hover': {
		backgroundColor: 'elevation.surface.hovered',
	},
});

export const TableRow: FC<{
	noBorder?: boolean;
	isSelected?: boolean;
	onClick?: () => void;
	testId?: string;
	isFlexibleHeight?: boolean;
	isDataRow?: boolean;
	children?: React.ReactNode;
}> = ({ children, noBorder, onClick, isSelected, isFlexibleHeight, isDataRow, ...props }) => {
	const buttonProps = {
		onClick,
		onKeyDown: (event: React.KeyboardEvent<HTMLTableRowElement>) => {
			if (event.key === 'Enter') {
				event.preventDefault();
				onClick?.();
			}
		},
	};

	return (
		<Box
			as="tr"
			xcss={[
				rowBaseStyle,
				Boolean(noBorder) && rowNoBorderStyle,
				Boolean(onClick) && rowButtonStyles,
				Boolean(isDataRow) && rowDataStyles,
				Boolean(isSelected) && rowSelectedStyle,
				Boolean(isFlexibleHeight) && rowFlexibleHeightStyle,
			]}
			{...props}
			{...(onClick ? buttonProps : {})}
			testId={props.testId}
		>
			{children}
		</Box>
	);
};
